import api from './api';

const authService = {
  // Inscription d'un utilisateur
  register: async (userData) => {
    // Create FormData if there's a file (profilePicture)
    let requestData;
    if (userData.profilePicture && userData.profilePicture instanceof File) {
      requestData = new FormData();
      
      // Add all fields to FormData
      Object.keys(userData).forEach(key => {
        if (key === 'profilePicture') {
          requestData.append('avatar', userData[key]);
        } else if (userData[key] !== null && userData[key] !== undefined) {
          requestData.append(key, userData[key]);
        }
      });
    } else {
      requestData = userData;
    }

    const response = await api.post('/auth/register', requestData);
    if (response.data?.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response;
  },

  // Inscription d'une organisation
  registerOrganization: async (organizationData) => {
    // Create FormData if there's a file (logo)
    let requestData;
    if (organizationData.logo && organizationData.logo instanceof File) {
      requestData = new FormData();
      
      // Add all fields to FormData
      Object.keys(organizationData).forEach(key => {
        if (key === 'logo') {
          requestData.append('logo', organizationData[key]);
        } else if (organizationData[key] !== null && organizationData[key] !== undefined) {
          requestData.append(key, organizationData[key]);
        }
      });
    } else {
      requestData = organizationData;
    }

    const response = await api.post('/organizations', requestData);
    // Vérifier response.token (structure backend organisation) ou response.data.token (structure standard)
    const token = response.token || response.data?.token;
    
    if (token) {
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response;
  },

  // Connexion
  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    if (response.data?.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response;
  },

  // Déconnexion
  logout: async () => {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  },

  // Récupérer les informations de l'utilisateur connecté
  getMe: async () => {
    return await api.get('/auth/me');
  },

  // Mettre à jour les détails de l'utilisateur
  updateDetails: async (userData) => {
    return await api.put('/auth/update-details', userData);
  },

  // Mettre à jour le mot de passe
  updatePassword: async (passwordData) => {
    return await api.put('/auth/updatepassword', passwordData);
  },

  // Demander une réinitialisation de mot de passe
  forgotPassword: async (email) => {
    return await api.post('/auth/forgotpassword', { email });
  },

  // Réinitialiser le mot de passe
  resetPassword: async (resetToken, password) => {
    return await api.put(`/auth/resetpassword/${resetToken}`, { password });
  },

  // Vérifier l'email
  verifyEmail: async (token) => {
    const response = await api.get(`/auth/verify-email/${token}`);
    // Si la vérification renvoie un token (auto-login), on le sauvegarde
    if (response.token || response.data?.token) {
      const jwt = response.token || response.data?.token;
      const user = response.data?.user || response.data?.data?.user;
      if (jwt && user) {
        localStorage.setItem('token', jwt);
        localStorage.setItem('user', JSON.stringify(user));
      }
    }
    return response;
  },

  // Renvoyer l'email de vérification
  resendEmailVerification: async () => {
    return await api.post('/auth/resend-verification');
  },

  // Vérifier le numéro de téléphone
  verifyPhone: async (verificationData) => {
    return await api.post('/auth/verify-phone', verificationData);
  },

  // Renvoyer le code de vérification SMS
  resendPhoneVerification: async (phoneNumber) => {
    return await api.post('/auth/resend-phone-verification', { phoneNumber });
  },

  // Vérifier si l'utilisateur est connecté
  isAuthenticated: () => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    return !!(token && user);
  },

  // Récupérer l'utilisateur depuis le localStorage
  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  // Récupérer le token depuis le localStorage
  getToken: () => {
    return localStorage.getItem('token');
  }
};

export default authService;